import { Injectable } from '@angular/core';
import { CardModel } from '../../components/card/models/card.model';

@Injectable({
  providedIn: 'root',
})
export class CardService {
  getCards(): CardModel[] {
    return [
      {
        title: 'Modéliser vos schémas de base de données',
        description: 'Créez et visualisez facilement vos modèles de données.',
        button: { text: 'Créer un modèle', link: '/database-model/menu' },
      },
      {
        title: 'Générez votre diagramme de séquence',
        description: 'Représentez graphiquement les interactions entre vos composants en quelques clics.',
        button: { text: 'Générer un diagramme', link: '/sequence-diagram' },
      },
      {
        title: 'Java vers UML',
        description: 'Convertissez votre code Java en diagrammes UML.',
        button: { text: 'Générer UML', link: '/umljava' },
      },
    ];
  }
}
